/*eslint-disable*/
import { exitRegistry } from '../utls/registry.js'

export default registry => {
  const registryClose = registry.querySelector('.js-registry-close')
  registryClose.addEventListener('click', () => {
    const popup = new Popup($('#registry-popup'))
    popup.show({
      before: function () {
        var $popup = this
        $popup.find('.tip-close a').click(function () {
          // Only mark the cookie as closed if it is blank, shouldn't happen
          popup.hide()
        })

        // exit-final
        $popup.find('.exit-final').click(function () {
          exitRegistry()
        })
      },
      after: function () {
        setTimeout(() => {
          $('body').on('click', function (e) {
            e.stopImmediatePropagation()
            if (!$(e.target).closest('.registry-popup:not(.template)').length) {
              popup.hide()
            }
          })
        }, 10)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/registry.js